import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_CaseClosureForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_CaseClosureForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center> <h3>CASE CLOSURE FORM </h3></center>
                </p>
                <p className='w-750'><center> <h3>DOCUMENTO PARA CERRAR LOS CASOS </h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> NAME OF CLIENT/ MEDICAID NUMBER/NOMBRE DEL CLIENTE :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> MEDICAID NUMBER/NÚMERO DE MEDICAID :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtNameOfClient' name='txttxtNameOfClient' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtMedicaidNumber' name='txttxtMedicaidNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='small w-250'> 
                 <h3><b>REASON FOR CLOSURE//MOTIVO PARA CERRAR EL CASO :</b> </h3>
                </p>
                <p className='small w-250'> (MARK THOSE THAT APPLY/MARQUE LOS QUE SE APLIQUEN)</p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientNoLongerRequired' name='cbClientNoLongerRequired' className='add-only' value='ClientNoLongerRequired' />
                            CLIENT NO LONGER REQUIRES CASE MANAGEMENT DUE TO ALL CLIENT/FAMILY NEEDS HAVING BEEN ADDRESSED/RESOLVED/EL CLIENTE YA NO REQUIERE LOS SERVICIOS DE ADMINISTRACIÓN DE CASOS PORQUE YA HAN SIDO SATISFECHAS/RESUELTAS
                            TODAS LAS NECESIDADES DEL CLIENTE/DE LA FAMILIA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientImprovementInHealthCondition' name='cbClientImprovementInHealthCondition' className='add-only' value='ClientImprovementInHealthCondition' />
                            CLIENT HAS IMPROVEMENT IN HEALTH CONDITION/LA SALUD DEL CLIENTE HA MEJORADO.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientTurned21' name='cbClientTurned21' className='add-only' value='ClientTurned21' />
                            CLIENT TURNED 21 YEARS OF AGE (FOR NON-PREGNANCY RELATED ELIGIBILITY)/
                            EL CLIENTE CUMPLE 21 AÑOS DE EDAD (PARA LOS CLIENTES QUE NO ESTÁN EMBARAZADAS).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientPostpartum' name='cbClientPostpartum' className='add-only' value='ClientPostpartum' />
                            CLIENT IS 59 DAYS POSTPARTUM/
                            LA CLIENTE DIO LA LUZ HACE 59 DÍAS.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientNoLongerQualifies' name='cbClientNoLongerQualifies' className='add-only' value='ClientNoLongerQualifies' />
                            CLIENT NO LONGER QUALIFIES FOR MEDICAID AND DOES NOT ANTICIPATE RE-ELIGIBILITY IN THE NEAR FUTURE/
                            EL CLIENTE DEJÓ DE SER ELEGIBLE PARA RECIBIR MEDICAID Y NO CREE QUE ESTARÍA ELEGIBLE PARA RECIBIRLO OTRA VEZ EN
                            UN FUTURO CERCANO.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientRequestClosure' name='cbClientRequestClosure' className='add-only' value='ClientRequestClosure' />
                            CLIENT/FAMILY REQUESTS CLOSURE/NO LONGER DESIRES SERVICES/
                            EL CLIENTE/LA FAMILIA PIDE CERRAR EL CASO O YA NO DESEA RECIBIR LOS SERVICIOS.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbApprovalForExtendedCase' name='cbApprovalForExtendedCase' className='add-only' value='ApprovalForExtendedCase' />
                            APPROVAL FOR EXTENDED CASE MANAGEMENT VISITS/SERVICES HAS BEEN DENIED/
                            SE NEGÓ LA APROBACIÓN PARA CONTINUAR CON LAS CITAS/SERVICIOS DE ADMINISTRACIÓN DE CASOS.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientLostToFollowUp' name='cbClientLostToFollowUp' className='add-only' value='ClientLostToFollowUp' />
                            CLIENT LOST TO FOLLOW-UP/UNABLE TO LOCATE (DOCUMENTATION SHOULD INCLUDE DATED ATTEMPTS TO LOCATE)/
                            EL CLIENTE NO SE PRESENTÓ A LAS CITAS COMPLEMENTARIAS O FUE IMPOSIBLE LOCALIZARLO (LA DOCUMENTACIÓN DEBE
                            INCLUIR LOS INTENTOS QUE SE HICIERON PARA LOCALIZARLO Y LAS FECHAS).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientRelocated' name='cbClientRelocated' className='add-only' value='ClientRelocated' />
                            CLIENT/FAMILY RELOCATED
                            CAMBIO DE DOMICILIO DEL CLIENTE/DE LA FAMILIA.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientDeceased' name='cbClientDeceased' className='add-only' value='ClientDeceased' />
                            CLIENT DECEASED; PARENT/GUARDIAN SIGNATURE NOT REQUIRED/
                            EL CLIENTE SE MURIÓ. NO SE REQUIERE LA FIRMA DEL PADRE O DEL TUTOR.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbClientClosureOther' name='cbClientClosureOther' className='add-only' value='ClientClosureOther' />
                            OTHER (SPECIFY)/OTRO
                            (EXPLIQUE)
                        </td>
                        <td className='w-375'><input type='text' id='txtReasonForClosureOther' name='txtReasonForClosureOther' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>I AM THE &nbsp;
                    <input type='radio' id='rbClient' name='rbClosure' className='add-only' value='Client' /> CLIENT&nbsp;
                    <input type='radio' id='rbParent' name='rbClosure' className='add-only' value='Parent' /> PARENT &nbsp;
                    <input type='radio' id='rbGuardian' name='rbClosure' className='add-only' value='Guardian' /> GUARDIAN &nbsp;
                    AND AGREE TO THE CLOSURE OF MY CASE/MY CHILD&#39;S CASE.</p>

                <p className='w-750'>YO SOY &nbsp;
                    <input type='radio' id='rbClientSpanish' name='rbClosureSpanish' className='add-only' value='ClientSpanish' /> EL CLIENTE&nbsp;
                    <input type='radio' id='rbParentSpanish' name='rbClosureSpanish' className='add-only' value='ParentSpanish' /> EL PADRE &nbsp;
                    <input type='radio' id='rbGuardianSpanish' name='rbClosureSpanish' className='add-only' value='GuardianSpanish' /> EL TUTOR Y ESTOY DE ACUERDO CON CERRAR MI CASO/EL CASO DE MI HIJO &nbsp;
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>CLIENT/PARENT/GUARDIAN SIGNATURE/
                            FIRMA DEL CLIENTE/DEL PADRE/DEL TUTOR: </td> &nbsp;&nbsp;
                        <td className='small w-200'>DATE/FECHA:</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>CASE MANAGER SIGNATURE/
                            FIRMA DEL ADMINISTRADOR DEL CASO:</td> &nbsp;&nbsp;
                        <td className='small w-200'>DATE/FECHA:</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> PRINTED NAME OF CASE MANAGER/
                                NOMBRE DE PROVEEDOR DE ADMINISTRACIÓN DE CASOS:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> CASE MANAGEMENT PROVIDER/AGENCY NAME/
                                NOMBRE DEL PROVEEDOR/DE LA AGENCIA DE ADMINISTRACIÓN DE
                                CASOS </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtNameOfClient' name='txttxtNameOfClient' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtMedicaidNumber' name='txttxtMedicaidNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>INTERPRETER SIGNATURE (IF APPLICABLE)/
                            FIRMA DEL INTÉRPRETE (EN CASO DE QUE LO HAYA):</td> &nbsp;&nbsp;
                        <td className='small w-200'>DATE/FECHA:</td>
                    </tr>
                </table>




            </div>
        </form>

    )
}











